/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {RankingAnnualView} from "../../ranking/views/RankingAnnualView";
import {RankingMainView} from "../../ranking/views/RankingMainView";
const route = [
    {bundlerEntry: "ranking", path: rpAppPath.ranking.base, component: RankingMainView},
    {bundlerEntry: "ranking", path: rpAppPath.ranking.city.base, component: RankingAnnualView},
    {bundlerEntry: "ranking", path: rpAppPath.ranking.city.annual, component: RankingAnnualView}
];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {RankingAnnualView} from "../../ranking/views/RankingAnnualView";
import {RankingMainView} from "../../ranking/views/RankingMainView";
const route = [
    {bundlerEntry: "ranking", path: rpAppPath.ranking.base, component: RankingMainView},
    {bundlerEntry: "ranking", path: rpAppPath.ranking.city.base, component: RankingAnnualView},
    {bundlerEntry: "ranking", path: rpAppPath.ranking.city.annual, component: RankingAnnualView}
];

(function () {
    rpClient(route);
})();
